import { Element } from "@craftjs/core";
import { ASSETS } from "../utils/config";
import { withWhiteSwatch } from "./swatchPalette";
import {
  ContainerWidget,
  TextWidget,
  ImageWidget,
  DividerWidget,
  VideoWidget,
  ImageWithTextWidget,
  Buttons,
  LinkWheelWidget,
  ImageGridWidget,
  SocialLinksWidget,
  DocumentWidget,
  AudioWidget,
} from "../components/SegmentBuilder/CodeBlocks";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { KeyboardArrowUp } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Accordion } from "../components/SegmentBuilder/CodeBlocks/Accordian";

export const BoxWidthTypes = {
  ContentWidth: { id: 1, image: ASSETS.segmentEditor.ContentWidth },
  FullWidth: { id: 2, image: ASSETS.segmentEditor.FullWidth },
};

const defaultText = <p>Hello there!</p>;
const segmentTools = [
  {
    id: 0,
    title: "Layout",
    backgroundColor: "#FFF5EA",
    elements: [
      {
        id: 0,
        title: "Container",
        image: ASSETS.segmentEditor.ImageGrid,
        component: <Element canvas is={ContainerWidget} padding={20} />,
        dataCy: "toolbox-container",
      },
      {
        id: 1,
        title: "Divider",
        image: ASSETS.segmentEditor.Divider,
        component: <DividerWidget />,
        dataCy: "toolbox-divider",
      },
    ],
  },
  {
    id: 1,
    title: "Content",
    backgroundColor: "#ECF2DA80",
    elements: [
      {
        id: 0,
        title: "Text",
        image: ASSETS.segmentEditor.Text,
        component: <TextWidget />,
        dataCy: "toolbox-text",
      },
      {
        id: 1,
        title: "Image/GIF",
        image: ASSETS.segmentEditor.Image,
        component: <ImageWidget />,
        dataCy: "toolbox-image",
      },
      {
        id: 2,
        title: "Video",
        image: ASSETS.segmentEditor.Video,
        component: <VideoWidget />,
        dataCy: "toolbox-video",
      },
      {
        id: 3,
        title: "Image With Text",
        image: ASSETS.segmentEditor.ImageWithText,
        component: <ImageWithTextWidget />,
        dataCy: "toolbox-image-text",
      },
      {
        id: 4,
        title: "Image Grid",
        image: ASSETS.segmentEditor.GridIcon,
        component: <ImageGridWidget />,
        dataCy: "toolbox-image-grid",
      },
      {
        id: 5,
        title: "Document",
        image: ASSETS.segmentEditor.Document,
        component: <DocumentWidget />,
        dataCy: "toolbox-document",
      },
      {
        id: 6,
        title: "Audio",
        image: ASSETS.segmentEditor.Audio,
        component: <AudioWidget />,
        dataCy: "toolbox-audio",
      },

      // { id: 3, title: "Image Above", image: ASSETS.segmentEditor.ImageAbove },
      // { id: 4, title: "Image Below", image: ASSETS.segmentEditor.ImageBelow },
    ],
  },
  {
    id: 2,
    title: "Interactive",
    backgroundColor: "#F6F7F9",
    elements: [
      {
        id: 0,
        title: "Accordion",
        image: ASSETS.segmentEditor.Accordion,
        component: <Accordion />,
        dataCy: "toolbox-accordion",
      },

      {
        id: 7,
        title: "Link Wheel",
        image: ASSETS.segmentEditor.LinkWheelIcon,
        component: <LinkWheelWidget />,
        dataCy: "toolbox-link-wheel",
      },

      {
        id: 1,
        title: "Button",
        image: ASSETS.segmentEditor.ButtonBlock,
        // component: <Element canvas is={ButtonsWidget} padding={20} />,
        component: <Buttons />,
        dataCy: "toolbox-buttons",
      },
      {
        id: 1,
        title: "Link Social Platforms",
        image: ASSETS.segmentEditor.Social,
        // component: <Element canvas is={ButtonsWidget} padding={20} />,
        component: <SocialLinksWidget />,
        dataCy: "toolbox-social",
      },
    ],
  },
];

export const ToolTabList = [
  {
    label: "Content Blocks",
    value: "0",
    disabled: false,
  },
  {
    label: "Appearance",
    value: "1",
    disabled: true,
  },
];

export const widgetNames = {
  TEXT: "TextWidget",
  CONTAINER: "ContainerWidget",
  DIVIDER: "DividerWidget",
  IMAGE: "ImageWidget",
  VIDEO: "VideoWidget",
  IMAGEWITHTEXT: "ImageWithText",
  IMAGEGRID: "ImageGridWidget",
  ACCORDION: "AccordionWidget",
  BUTTON: "ButtonWidget",
  LINKWHEEL: "LinkWheelWidget",
  SOCIALLINKS: "SocialLinksWidget",
  DOCUMENT: "DocumentWidget",
  AUDIO: "AudioWidget",
};

export const solidColors = withWhiteSwatch([
  "#E9ECEF",
  "#DEE2E6",
  "#CED4DA",
  "#ADB5BD",
  "#868E96",
  "#495057",
  "#343A40",
  "#212529",
  "#C92A2A",
  "#862E9C",
  "#5F3DC4",
  "#364FC7",
  "#1864AB",
  "#087F5B",
  "#2B8A3E",
  "#5C940D",
  "#E67700",
  "#D9480F",
  "#FA5252",
  "#CC5DE8",
  "#5C7CFA",
  "#339AF0",
  "#20C997",
  "#51CF66",
  "#FCC419",
  "#FF922B",
  "#FFC9C9",
  "#EEBEFA",
  "#D0BFFF",
  "#BAC8FF",
  "#A5D8FF",
  "#96F2D7",
  "#B2F2BB",
  "#D8F5A2",
  "#FFEC99",
  "#FFD8A8",
]);

export const searchEngines = {
  image: [
    { id: 0, key: 1, title: "Images", items: [] },
    { id: 1, key: 2, title: "Gifs", items: [] },
  ],
  images: [
    { id: 0, key: 1, title: "Images", items: [] },
    { id: 1, key: 2, title: "Gifs", items: [] },
  ],
  video: [{ id: 0, key: 1, title: "Youtube", items: [] }],
};

export const breakpointColumnsObj = {
  default: 4,
  1100: 3,
  700: 2,
  500: 1,
};

export const initialKeywords = [
  { id: 0, title: "Abstract" },
  { id: 1, title: "Animal" },
  { id: 2, title: "Architecture" },
  { id: 3, title: "Art" },
  { id: 4, title: "Business" },
  { id: 5, title: "Colorful" },
  { id: 6, title: "Food" },
  { id: 7, title: "Interior" },
  { id: 8, title: "Minimal" },
  { id: 9, title: "Nature" },
  { id: 10, title: "Plant" },
  { id: 11, title: "Portrait" },
  { id: 12, title: "Space" },
  { id: 13, title: "Technology" },
  { id: 14, title: "Texture" },
  { id: 15, title: "Wallpaper" },
];

export const MEDIA_TYPE = {
  image: 1,
  images: 1,
  video: 2,
  gif: 3,
};

export const ACCORDION_DROPDOWN_BUTTON_STYLE = [
  {
    id: 0,
    key: 0,
    title: "Up / Down",
    icons: [
      {
        id: 0,
        component: <KeyboardArrowUp />,
      },
      {
        id: 1,
        component: <KeyboardArrowDownIcon />,
      },
    ],
  },
  {
    id: 1,
    key: 1,
    title: "Plus / Minus",
    icons: [
      {
        id: 0,
        component: <AddIcon />,
      },
      {
        id: 1,
        component: <RemoveIcon />,
      },
    ],
  },
];

export const VISIBILITY_KEY = {
  PUBLIC: 1,
  PRIVATE: 2,
  HIDDEN: 3,
};

export const GRID_TYPES = {
  STANDARD: "standard",
  QUILTED: "quilted",
  MASONRY: "masonry",
};

export default segmentTools;
